import { Controller } from "@hotwired/stimulus"
import { apiPost, t } from "../api_helper"

export default class extends Controller {
  static targets = ["slide", "dots", "nextBtn", "skipBtn"]

  connect() {
    this.currentSlide = 0
    this.totalSlides = this.slideTargets.length
    this.showSlide(0)
  }

  showSlide(index) {
    this.slideTargets.forEach((slide, i) => {
      slide.classList.toggle("hidden", i !== index)
      if (i === index) {
        slide.classList.add("fade-in")
      }
    })

    if (this.hasDotsTarget) {
      const dots = this.dotsTarget.querySelectorAll("[data-dot]")
      dots.forEach((dot, i) => {
        if (i === index) {
          dot.style.backgroundColor = "rgb(99,102,241)"
          dot.style.opacity = "1"
          dot.style.transform = "scale(1.2)"
        } else {
          dot.style.backgroundColor = "rgb(148,163,184)"
          dot.style.opacity = "0.3"
          dot.style.transform = "scale(1)"
        }
      })
    }

    const isLast = index === this.totalSlides - 1

    if (this.hasNextBtnTarget) {
      this.nextBtnTarget.textContent = isLast
        ? (t("onboarding.start") || "Get Started")
        : (t("onboarding.next") || "Next")
    }

    if (this.hasSkipBtnTarget) {
      this.skipBtnTarget.classList.toggle("hidden", isLast)
    }
  }

  next() {
    if (this.currentSlide < this.totalSlides - 1) {
      this.currentSlide++
      this.showSlide(this.currentSlide)
    } else {
      this.complete()
    }
  }

  skip() {
    this.complete()
  }

  async complete() {
    try {
      await apiPost("/api/onboarding/complete", {})
      window.location.href = "/pwa"
    } catch (e) {
      console.error("Onboarding complete error:", e)
      window.location.href = "/pwa"
    }
  }
}
